module.exports = __webpack_public_path__ + "img/top.d41390a0.jpg";